/*
 *  I15TAUXCOUVBOISCalcul.ts
 *
 *  Created by Sébastien Hecart on 2022-06-27 10:29:55 +0000.
 *  Copyright © 2022 Sebastien Hecart - Fahbe Company - . All rights reserved.
 *
 */

import { I15TAUXCOUVBOIS_State } from '@batical/types/src'

function I15TAUXCOUVBOIS_docalcul(state: I15TAUXCOUVBOIS_State) {
  const { in_puissance_total, in_puissance_biomasse } = state
  if (in_puissance_total === 0) {
    state.res_couverture_biomasse = 0
    return state
  }
  if (in_puissance_total < in_puissance_biomasse) {
    state.res_couverture_biomasse = 100
    return state
  }

  state.res_couverture_biomasse = (1 - Math.pow(1 - in_puissance_biomasse / in_puissance_total, 3)) * 100
  return state
}

export default I15TAUXCOUVBOIS_docalcul
